import React from 'react';
import Icon from 'components/lib/icons/icon';

/**
 * @visibleName Chevron Right Stroke
 */

export default function ChevronRightStrokeIcon(props) {
  return (
    <Icon viewBox="0 0 16 16" {...props}>
      <path
        clipRule="evenodd"
        d="M4.14645 2.13518C4.34171 1.95494 4.65829 1.95494 4.85355 2.13518L10.8536 7.67364C11.0488 7.85389 11.0488 8.14612 10.8536 8.32636L4.85355 13.8648C4.65829 14.0451 4.34171 14.0451 4.14645 13.8648C3.95118 13.6846 3.95118 13.3923 4.14645 13.2121L9.79289 8L4.14645 2.7879C3.95118 2.60765 3.95118 2.31542 4.14645 2.13518Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </Icon>
  );
}
